<template>
    <div class="iwu">
        <input class="iwu-input" type="number" v-model="value" min="0" placeholder="auto" @input="changeValue()" />
        <select class="iwu-unit" v-model="unit" @change="changeUnit()">
            <option value="px">px</option>
            <option value="rem">rem</option>
            <option value="%">%</option>
        </select>
        <a v-if="hasValue" title="Unset value" class="iwu-clear" role="button" @click="unsetValues()"><i class="fas fa-times-circle"></i></a>
    </div>
</template>
<script>
export default {
    name: "InputWithUnit",
    props: ["title", "values"],
    data: () => ({
        value: "",
        unit: "px",
    }),
    created() {
        if (this.values) {
            if (String(this.values).includes("rem")) this.unit = "rem";
            else if (String(this.values).includes("%")) this.unit = "%";
            else this.unit = "px";
            const n = parseFloat(this.values);
            this.value = isNaN(n) ? "" : n;
        } else {
            this.value = "";
        }
    },
    methods: {
        emitValue() {
            const n = parseFloat(this.value);
            // empty / non-numeric → emit "" so the style key is UNSET (falls back to default)
            this.$emit("changeValue", this.value === "" || this.value === null || isNaN(n) ? "" : `${n}${this.unit}`);
        },
        changeValue() {
            this.emitValue();
        },
        changeUnit() {
            this.emitValue();
        },
        // the × clears the value entirely (unset), not "0px"
        unsetValues() {
            this.value = "";
            this.$emit("changeValue", "");
        },
    },
    computed: {
        hasValue() {
            return this.value !== "" && this.value !== null && this.value !== undefined && !isNaN(parseFloat(this.value));
        },
    },
    emits: ["changeValue"],
};
</script>
<style scoped>
.iwu {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 275px;
    max-width: 100%;
}
.iwu-input {
    flex: 1;
    min-width: 0;
    height: 31.5px;
    background: #fff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    color: #333;
    font-size: 13px;
    padding: 2px 10px;
    outline: none;
    box-sizing: border-box;
    -moz-appearance: textfield;
}
.iwu-input::-webkit-inner-spin-button,
.iwu-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.iwu-unit {
    flex: 0 0 64px;
    height: 31.5px;
    background: #fff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    color: #333;
    font-size: 13px;
    padding: 2px 6px;
    outline: none;
    box-sizing: border-box;
    cursor: pointer;
}
.iwu-clear {
    flex: 0 0 auto;
    color: #ef4444;
    font-size: 14px;
    cursor: pointer;
    line-height: 1;
    display: inline-flex;
    align-items: center;
}
</style>
